// cost-per-serve.js
//
// Decorates Cornerstone's native chip-based variant picker with a live
// "= Xc / cup" (or "$X.XX / cup" once it crosses $1) summary that updates
// as the customer clicks between Size chips.
//
// Relies on the public `product:variant-change` event, which Cornerstone
// fires with the full variant object at evt.detail.variant whenever a
// new variant is selected.
//
// The per-chip "= N cups" labels and the "Best Value" / "Popular" badges
// are static and rendered entirely server-side in product-variant-picker.liquid,
// so this file only needs to handle the one genuinely dynamic piece.

(function () {
  function parseGramsFromOptionValue(text) {
    if (!text) return 0;

    var normalized = text.toLowerCase().trim();

    if (normalized === 'taster' || normalized === 'sample') {
      return 0;
    }

    if (normalized.indexOf('kg') > -1) {
      var kgValue = parseFloat(normalized.replace('kg', '').trim());
      return isNaN(kgValue) ? 0 : kgValue * 1000;
    }

    if (normalized.indexOf('g') > -1) {
      var gValue = parseFloat(normalized.replace('g', '').trim());
      return isNaN(gValue) ? 0 : gValue;
    }

    return 0;
  }

  function formatCostPerServe(cents) {
    var rounded = Math.round(cents);

    if (rounded < 100) {
      return rounded + 'c';
    }

    return '$' + (rounded / 100).toFixed(2);
  }

  function updateCpsDisplay(variant) {
    var displays = document.querySelectorAll('[data-cps-display]');

    displays.forEach(function (el) {
      var gramsPerServe = parseFloat(el.getAttribute('data-cps-grams-per-serve'));
      var optionIndex = el.getAttribute('data-cps-option-index');
      var sizeText = variant['option' + optionIndex];

      var grams = parseGramsFromOptionValue(sizeText);

      if (!grams || !gramsPerServe) {
        el.hidden = true;
        return;
      }

      var servings = Math.floor(grams / gramsPerServe);

      if (servings < 1) {
        el.hidden = true;
        return;
      }

      var costPerServeCents = variant.price / servings;
      var valueEl = el.querySelector('[data-cps-value]');

      if (valueEl) {
        valueEl.textContent = formatCostPerServe(costPerServeCents);
      }

      el.hidden = false;
    });
  }

  document.addEventListener('product:variant-change', function (evt) {
    if (evt.detail && evt.detail.variant) {
      updateCpsDisplay(evt.detail.variant);
    }
  });
})();
